import * as Stomp from 'stompjs';

class WebSocketService {

    constructor() {
        if (!WebSocketService.instance) {
            this.stompClient = null;
            this.isConnected = false;
            this.topics = [];
            this.connect(window.CONFIG.SWS_SERVER_WS.url)
            WebSocketService.instance = this;
        }
        return WebSocketService.instance;
    }

    // Connect WebSocket
     connect(url) {
        if (this.isConnected) {
            console.log('WebSocket is already connected.');
            return;
        }

        let socket = new WebSocket(url);
        socket.onerror = (error) => {
            console.log('WebSocket error', error);
        };

        this.stompClient = Stomp.over(socket);
        this.stompClient.connect(
            {},
            () => {
                console.log('WebSocket connected successfully');
                this.isConnected = true;
                // Subscribe to all topics once the connection is established
                this.topics.forEach(topic => this.subscribe(topic));
            },
            (err) => {
                console.log('WebSocket connection error', err);
                // Retry connection after 5 seconds if there's an error
                setTimeout(() => this.connect(url), 5000);
            }
        );
    }

    // Subscribe to a topic
     subscribe(topic, callback) {
        if (!this.isConnected) {
            console.log('WebSocket is not connected');
            return;
        }

        this.stompClient.subscribe(
            topic,
            callback,
            { id: topic }
        );
    }

    // Unsubscribe from a topic
     unsubscribe(topic) {
        if (!this.isConnected) {
            console.log('WebSocket is not connected');
            return;
        }

        this.stompClient.unsubscribe(topic);
        console.log(`Unsubscribed from topic: ${topic}`);
    }

    // Disconnect WebSocket
     disconnect() {
        if (this.stompClient) {
            this.stompClient.disconnect(() => {
                this.isConnected = false;
                console.log('WebSocket disconnected');
            });
        }
    }
}

const webSocketService = new WebSocketService();

export default webSocketService;
